import { render, staticRenderFns } from "./CoursewareToolbarBlocks.vue?vue&type=template&id=8bfe4bf6&"
import script from "./CoursewareToolbarBlocks.vue?vue&type=script&lang=js&"
export * from "./CoursewareToolbarBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports